import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class TovpilCookieService {

    constructor(private cookieService: CookieService) { }

    // Añadir un objeto o lista serializado en una cookie
    async addObjectCookie(name: string, value: any, expires?: number | Date, path?: string, domain?: string, secure?: boolean, sameSite?: 'Lax' | 'None' | 'Strict'): Promise<void> {
        console.log("Crear Cookie");
        const serializedValue = btoa(JSON.stringify(value));
        this.cookieService.set(name, serializedValue, expires, environment.cookiePath, environment.cookieDomain, secure, sameSite);
    }

    // Obtener un objeto o lista deserializado de una cookie
    getObjectCookie<T>(name: string): T | undefined {
        const serializedValue = this.cookieService.get(name);
        if (serializedValue) {
            return JSON.parse(serializedValue) as T;
        }
        return undefined;
    }

    // Actualizar un objeto o lista serializado en una cookie
    updateObjectCookie(name: string, value: any, expires?: number | Date, path?: string, domain?: string, secure?: boolean, sameSite?: 'Lax' | 'None' | 'Strict'): void {
        console.log("Actualizar Cookie");
        const serializedValue = JSON.stringify(value);
        if (this.cookieService.check(name)) {
            this.cookieService.delete(name, environment.cookiePath, environment.cookieDomain);
        }
        this.cookieService.set(name, serializedValue, expires, environment.cookiePath, environment.cookieDomain, secure, sameSite);
    }

    // Eliminar una cookie
    async deleteCookie(name: string, path?: string, domain?: string): Promise<void> {
        console.log("Elimina Cookie");
        this.cookieService.delete(name, environment.cookiePath, environment.cookieDomain);
    }
}
